
import Vue, {PropType} from "vue";
import {SeriesData, ServerData} from "@/interfaces";

export default Vue.extend({
  name: "SeriesSelector",
  props: {
    serverData: Object as PropType<ServerData>
  },
  data() {
    return {
      onlyCampaigns: false,
      showOneShots: true,
      search: ""
    };
  },
  computed: {
    sortedSeries(): SeriesData[] {
      return this.serverData.series.filter((series) => {
        if (!series.is_campaign && this.onlyCampaigns) {
          return false;
        }
        if ((series.length === 1 && !series.is_campaign) && !this.showOneShots) {
          return false;
        }
        return this.search === "" || series.title.toLowerCase().includes(this.search.toLowerCase());

      }).sort((a, b) => {
        return b.last_upload.localeCompare(a.last_upload);
      });
    }
  },
  methods: {
    selectSeries(): void {
      // @ts-ignore
      this.$parent.showSeriesSelector = false;
    },
    createLink(series: SeriesData) {

      const episode = (series.length === 1 && !series.is_campaign) ? "-" : 10;
      return {
        name: "search",
        params: {series: series.slug, episode}
      };
    }
  }
});
